module.exports = __webpack_public_path__ + "media/application/images/external-services/walmart-logo-bae2bcfdd8708af58e811c988fcce5df.svg";